<template>
    <div>
        <v-btn @click="showFilterDrawerNew = !showFilterDrawerNew" class="white rounded-of" depressed>
            <div class="title pr-4 removetexttransform">{{ $t("filter") }}</div>
            <v-icon class="primary--text" x-large>icons8-slider</v-icon>
        </v-btn>
        <v-navigation-drawer v-model="showFilterDrawerNew" temporary app right
            class="foreground-highest white rounded-of-left-xl menupanel filterpanel" height="100%" overlay-opacity="0.8">
            <v-row class="d-flex align-space-around full-height">
                <v-col cols="12">
                    <v-row class="pt-10 pl-5 d-flex align-start">
                        <v-col cols="12" class="d-flex justify-end pr-5">
                            <v-icon @click="showFilterDrawerNew = !showFilterDrawerNew"
                                class="primary--text">icons8-close</v-icon>
                        </v-col>
                        <v-col cols="12" class="d-flex align-center">
                            <v-icon class="primary--text" style="font-size:2em;">icons8-slider</v-icon>
                            <div class="title pl-3">{{ $t("filter") }}</div>
                        </v-col>
                        <v-col cols="12" class="pt-10" style="margin-bottom: -1em;">
                            <div class="title">{{ $t("businesstype") }}</div>
                            <v-radio-group v-if="$i18n.locale === 'en'" v-model="businessType">
                                <v-radio v-for="(type, index) in businessTypes" :key="index" :label="`${type.label}`"
                                    :value="type.value" class="dietselectradio pb-2"></v-radio>
                            </v-radio-group>
                            <v-radio-group v-if="$i18n.locale === 'cy'" v-model="businessType">
                                <v-radio v-for="(type, index) in businessTypesCy" :key="index" :label="`${type.label}`"
                                         :value="type.value" class="dietselectradio pb-2"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <!-- <v-col class="d-flex align-center" style="margin-bottom: -1em;">
                            <div class="title pr-2" style="font-weight: 900 !important;">{{ $t("distance") }}: </div>
                            <div class="title"> {{ distance }} {{ $t("miles") }}</div>
                        </v-col>
                        <v-col cols="12">
                            <v-slider v-model="distance" min="2" max="15" track-color="lightgrey"
                                class="filterslider"></v-slider>
                        </v-col> -->
                    </v-row>
                </v-col>

                <!-- LOCATION TEST -->
                <!-- <v-col cols="12" class="text-center px-5 d-flex align-end pb-7">
                    <v-btn @click="locationTest()"
                        class="primary rounded-of text-body-2 font-weight-bold white--text removetexttransform filtersubmitbutton"
                        block x-large depressed>
                        <div class="title full-width text-center">Location Test</div>
                    </v-btn>
                </v-col>
                <v-col class="d-flex align-center justify-center" v-if="loading">
                    <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
                </v-col>
                <v-col cols="12" v-if="userLatitude != ''" class="d-flex align-center justify-center flex-column">
                    <div class="title">your location:</div>
                    <div class="title">{{ userLatitude }} : {{ userLongitude }}</div>
                </v-col> -->
                
                <v-col cols="12" class="text-center px-5 d-flex align-end pb-7">
                    <v-btn @click="submitFilter()" v-bind:loading="loading"
                        class="primary rounded-of text-body-2 font-weight-bold white--text removetexttransform filtersubmitbutton"
                        block x-large depressed>
                        <div class="title full-width text-center">{{ $t("submit") }}</div>
                    </v-btn>
                </v-col>
            </v-row>

        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
    computed: {
        computedViewportheight() {
            return window.innerHeight;
        },
    },
    data: () => ({
        distance: 2,
        showFilterDrawerNew: false,
        businessType: "",
        userLatitude: "",
        userLongitude: "",
        loading: false,
        items: [
            { title: "Home", icon: "mdi-view-dashboard" },
            { title: "About", icon: "mdi-forum" },
        ],
        businessTypes: [
            {label: "All", value: ""},
            // {label: "Restaurant", value: "restaurant"},
            {label: "Hospitality", value: "hospitality"},
            {label: "Entertainment", value: "entertainment"},
            {label: "Retail", value: "retail"},
            {label: "Public", value: "public"},
            {label: "Hotel", value: "hotel"},
            {label: "Finance", value: "finance"},
            {label: "Legal", value: "legal"},
            {label: "Education", value: "education"},
            {label: "Professional", value: "professional"},
        ],
        businessTypesCy: [
            {label: "Popeth", value: ""},
            // {label: "Restaurant", value: "restaurant"},
            {label: "Lletygarwch", value: "hospitality"},
            {label: "Adloniant", value: "entertainment"},
            {label: "Manwerthu", value: "retail"},
            {label: "Cyhoeddus", value: "public"},
            {label: "Gwesty", value: "hotel"},
            {label: "Cyllid", value: "finance"},
            {label: "Cyfreithiol", value: "legal"},
            {label: "Addysg", value: "education"},
            {label: "Proffesiynol", value: "professional"},
        ],
    }),
    methods: {
        submitFilter() {
            this.loading = true;
                this.$emit("filterSubmit", this.businessType);
                this.showFilterDrawerNew = false;
                this.loading = false;
        },
        locationTest() {
            this.loading = true;
            this.$getLocation()
                .then(coordinates => {
                    // console.log(coordinates);
                    this.userLatitude = coordinates.lat;
                    this.userLongitude = coordinates.lng;
                    this.loading = false;
                });
        },

    },
    watch: {

    },
    created() {

    },
};
</script>

<style>
/* .v-btn__content {
background-color: black;
} */

.filterslider {
    padding-right: 0.7em;
}

.filterslider .v-slider__track-container {
    height: 10px;
}

.filterslider .v-slider__track-container .v-slider__track-background {
    border-radius: 15px;
}

.filterslider .v-slider__track-container .v-slider__track-fill {
    border-radius: 15px;
}

.filterslider .v-slider__track {
    height: 10px;
}

.filterslider .v-slider__thumb {
    height: 1.5em;
    width: 1.5em;
}

.filterslider .v-slider__thumb::before {
    display: none !important;
}

.dietselectradio .v-label {
    color: black !important;
    font-size: 1.25rem !important;
}

.dietselectradio .v-input--selection-controls__input .mdi-radiobox-blank {
    color: transparent !important;
    background: #F0F0F0 !important;
    border-radius: 2em !important;
    font-size: 5px !important;
}

.dietselectradio .v-input--selection-controls__input .mdi-radiobox-marked {
    color: transparent !important;
    background: #CC0200 !important;
    border-radius: 2em !important;
}

.dietselectradio .v-input--selection-controls__input .v-input--selection-controls__ripple {
    display: none !important;
}
</style>

<style scoped>
.menubutton {
    min-height: 20px !important;
    height: 80px !important;
}

.bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    padding: 20px;
}

.menupanel {
    padding: 1em !important;
    max-height: none !important;
    overflow: visible !important;
}

.filtersubmitbutton {
    height: 4.5em !important;
}

.filterpanel {
    width: 75% !important;
    position: fixed !important;
}

.v-overlay {
    position: fixed !important;
}

@media only screen and (min-width: 768px) {
    .filterpanel {
        width: 40% !important;
    }
}</style>
